import React, { useEffect, useState } from "react";
import { Col, Row, Select } from "antd";
import { Controller, useForm } from "react-hook-form";
import styles from "./add-edit-rooms.module.css";
import CustomDrawer from "../../../../../../../../../common/custom-drawer/custom-drawer";
import CustomTextfield from "../../../../../../../../../common/input/custom-textfield/custom-textfield";
import CustomButton from "../../../../../../../../../common/custom-button/custom-button";
import { toast } from "react-toastify";
import { createRooms, updateRooms } from "../../../../../../../../../services/school_info";
import CustomSelect from "../../../../../../../../../common/input/custom-select/custom-select";
import { ROOM_TYPES } from "../../../../../../../../../constants/common";

const { Option } = Select;

const AddEditRooms = ({ open, onClose, data }) => {
  const [loading, setLoading] = useState(false);
  const { control, getValues, reset, trigger } = useForm({
    mode: "onChange",
    defaultValues: {
      room_number: "",
      building_name: "",
      room_type: "",
      room_capacity: "",
    },
  });

  useEffect(() => {
    if (data?.id) {
      reset({
        room_number: data?.room_number,
        building_name: data?.building_name,
        room_type: data?.room_type,
        room_capacity: data?.room_capacity,
      });
    } else {
      reset({
        room_number: "",
        building_name: "",
        room_type: "",
        room_capacity: "",
      });
    }
  }, [data]);

  const handleSubmit = async () => {
    try {
      const isValid = await trigger();
      if (!isValid) {
        return;
      }

      const formValues = getValues();
      const payload = {
        room_number: formValues?.room_number,
        building_name: formValues?.building_name,
        room_type: formValues?.room_type,
        room_capacity: formValues?.room_capacity,
      };
      if (data?.id) await updateRooms(data?.id, payload);
      else await createRooms(payload);
      toast.success(`Room ${data?.id ? "edited" : "created"} successfully!`);
      handleClose();
    } catch (err) {
      toast.error(err?.data?.message || `Failed to ${data?.id ? "edit" : "create"} room`);
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <CustomDrawer
      title={`${data?.id ? 'Edit' : 'Add New'} Room`}
      open={open}
      onClose={handleClose}
      className={styles.drawer}
      footer={
        <div className={styles.footerWrapper}>
          <CustomButton
            onClick={handleClose}
            title="Back"
            variant="outlined"
            className={styles.footerBackButton}
          />
          <CustomButton
            title={`${data?.id ? "Edit" : "Add New"} Room`}
            size="large"
            onClick={handleSubmit}
          />
        </div>
      }
      width="40vw"
      drawerStyles={{ body: { padding: "50px" } }}
    >
      <Row gutter={[0, 20]}>
        <Col span={24}>
          <Controller
            name="room_number"
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <CustomTextfield
                id="room_number"
                label="Room Number"
                showRequired
                labelColor="#171717"
                placeholder="Enter Room Number"
                type="number"
                size="large"
                value={value}
                onChange={onChange}
                status={error ? "error" : ""}
              />
            )}
          />
        </Col>

        <Col span={24}>
          <Controller
            name="building_name"
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <CustomTextfield
                id="building_name"
                label="Building Name"
                showRequired
                labelColor="#171717"
                placeholder="Enter Building Name"
                size="large"
                value={value}
                onChange={onChange}
                status={error ? "error" : ""}
              />
            )}
          />
        </Col>

        <Col span={24}>
          <Controller
            name="room_type"
            control={control}
            rules={{ required: true }}
            render={({
              field: { onChange, value },
              fieldState: { error },
            }) => (
              <CustomSelect
                id="room_type"
                label="Room Type"
                showRequired
                labelColor="#171717"
                placeholder="--Select--"
                showSearch
                size="large"
                value={value}
                onChange={onChange}
                status={error ? "error" : ""}
              >
                {ROOM_TYPES?.map((option, index) => (
                  <Option key={`${option?.value}-${index}`} value={option?.value}>
                    {option?.label}
                  </Option>
                ))}
              </CustomSelect>
            )}
          />
        </Col>

        <Col span={24}>
          <Controller
            name="room_capacity"
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <CustomTextfield
                id="room_capacity"
                label="Room Capacity"
                showRequired
                labelColor="#171717"
                placeholder="Enter Room Capacity"
                type="number"
                size="large"
                value={value}
                onChange={onChange}
                status={error ? "error" : ""}
              />
            )}
          />
        </Col>
      </Row>
    </CustomDrawer>
  );
};

export default AddEditRooms;
